import { Zap } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative z-[2] border-t border-white/10 bg-[#050505]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="grid place-items-center w-8 h-8 bg-[#e2ff00] text-black rounded-sm">
                <Zap size={18} strokeWidth={2.5} />
              </span>
              <span className="font-display font-extrabold tracking-tight text-lg">OG VAULT</span>
            </div>
            <p className="text-sm text-[#8b8b93] leading-relaxed">
              Der Tresor für die seltensten OG Fortnite Accounts. Verifiziert, Full Access, sofort geliefert.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-10 font-mono text-sm">
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#54545c] mb-4">Shop</div>
              <ul className="space-y-2.5 text-[#8b8b93]">
                <li><button onClick={() => document.getElementById("vault")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-white transition-colors">Alle Packs</button></li>
                <li><button onClick={() => document.getElementById("how")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-white transition-colors">So funktioniert's</button></li>
              </ul>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#54545c] mb-4">Zahlung</div>
              <ul className="space-y-2.5 text-[#8b8b93]">
                <li>PayPal</li>
                <li>Klarna</li>
              </ul>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#54545c] mb-4">Support</div>
              <ul className="space-y-2.5 text-[#8b8b93]">
                <li>24/7 Chat</li>
                <li>Verifizierte Lieferung</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 font-mono text-xs text-[#54545c]">
          <span>© {new Date().getFullYear()} OG VAULT. Kein offizielles Produkt von Epic Games.</span>
          <span>Nicht mit Epic Games oder Fortnite verbunden.</span>
        </div>
      </div>
    </footer>
  );
};
